import { memo } from 'react';
import { UploadPrimitive } from './primitive';
import { useI18n } from '@/providers/i18n';
import { areNodePropsEqual } from '../are-node-props-equal';

export type UploadNodeProps = {
  type: string;
  data: {
    content?: {
      url: string;
      type: string;
      name?: string;
    };
    /** 文件类型：'image' | 'video' | 'audio' | 'model' */
    fileType?: 'image' | 'video' | 'audio' | 'model';
    /** 原始导入的文件 URL（通过工具栏输入的 URL） */
    sourceUrl?: string;
    /** 图片相关 */
    size?: string;
    width?: number;
    height?: number;
    description?: string;
    /** 音频相关 */
    durationSeconds?: number;
    transcript?: string;
    /** 视频相关 */
    updatedAt?: string;
    /** 主体相关（来自主体库拖入） */
    subject?: boolean;
    /** 主体模式：mosaic 拼图 | multi 多图组（封面=首图，subjectImages 存全部原图） */
    subjectMode?: 'mosaic' | 'multi';
    /** multi 主体时保留的全部原图 URL 数组（封面=subjectImages[0]） */
    subjectImages?: string[];
  };
  id: string;
};

export const UploadNode = memo((props: UploadNodeProps) => {
  const { t } = useI18n();
  return <UploadPrimitive {...props} title={t('Upload Node')} />;
}, areNodePropsEqual);
UploadNode.displayName = 'UploadNode';

